import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import helpers from "@/helpers";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        view: 'kassa',
        loader: false,
        fbclid: null,
        transportProvince: {},
        layers: [],
        SubCategories: [],
        CurrentCategory: [],
        order: {
            rows: [],
            contact: {
                persons: [
                    {
                        firstName: null,
                        lastName: null,
                        personNr: null,
                        email: null,
                        phone: null,
                        altPhone: null,
                        address: null,
                        zip: null,
                        city: null,
                        propertyName: null,
                        foundus: 'disabledOption'
                    }
                ],
                tidsPlan:[],
                KontaktWay:[],
                address: null,
                zip: null,
                city: null,
                propertyName: null,
                municipality: null,
                messageToSeller: null
            },
            controlPoints: [],
            misc: {
                euroRate: null
            }
        },
        gclick_id: null,
        infoArticle: {},
        activeTab:'ProductChooser',
        transport_list:[],
        showallOptions:true,
        clicking:false,
    },
    getters: {
        SubCategories: state => {
            return state.SubCategories.filter(object => object.HideForCustomer !== true && object.LinkedArticles.length > 0)
        },
        CurrentCategoryIndex: state => {
            return state.SubCategories.findIndex(object => object.category_nr === state.CurrentCategory.category_nr)
        },
        totalPrice: state => {
            return state.order.rows.map(r => r.article).reduce((t, a) => t + helpers.calculateTotalInc(a), 0)
        },

    },
    mutations: {
        commit_clicking(state, payload){
            state.clicking = payload
        },
        reset_select_row(state, payload){
            state.order.rows[payload.index] = payload.val
        },
        commit_showallOptions(state, payload) {
            state.showallOptions = !state.showallOptions
            Array.from(document.querySelectorAll('#PrefabCreator_topMenu_ul a')).forEach((x,i)=>{
                x.classList.remove('current')
                if(i === 0){
                    x.classList.add('current')
                }
            })
            if(state.showallOptions){
                const firstObjectWithFalseValue = state.SubCategories.find(object => object.HideForCustomer === false)
                state.view = firstObjectWithFalseValue.category_nr
                state.CurrentCategory = firstObjectWithFalseValue
            }
        },
        commit_activeTab(state, payload) {
            state.activeTab = payload
        },
        closeInfoWindow(state, payload) {
            state.infoArticle = []
            document.getElementById('InfoWindow').classList.remove('active')
        },
        commit_infoArticle(state, payload) {
            state.infoArticle = payload
            document.getElementById('InfoWindow').classList.toggle('active')
        },
        commit_house(state, payload) {
            state.hus = payload
        },
        commit_kommun(state, payload) {
            state.kommun = payload
        },
        commit_firstperson_details(state, payload) {
            state.order.contact.persons[0][payload.type] = payload.val
        },
        commit_contact_details(state, payload) {
            state.order.contact[payload.type] = payload.val
            if (!payload.b) {
                state.order.contact.persons[0][payload.type] = payload.val
            }

        },
        commit_active_row(state,payload) {
           let index = state.order.rows.findIndex(x => x.article.sub_category === payload.article.sub_category)
            state.order.rows.splice(index + 1, 0, payload)
            state.order.rows.splice(index, 1)

            if (window.location.hostname !== 'localhost') {
                dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object
                let items = []
                Array.from(state.order.rows).forEach(function (x) {
                    items.push({
                        item_id: x.article.article_nr,
                        item_name: x.article.title,
                        affiliation: "PrefabByggonline",
                        coupon: "",
                        discount: x.article.discount,
                        index: x.article.order !== undefined ? x.article.order : '',
                        item_brand: x.article.manufacturer,
                        item_category: x.article.top_head_category !== undefined ? x.article.top_head_category : '',
                        item_category2: x.category.title,
                        item_list_id: x.category.category_nr,
                        item_list_name: x.category.section,
                        item_variant: x.article.telverkare_color !== undefined ? x.article.telverkare_color : '',
                        location_id: x.article.manufaktur_artnr !== undefined ? x.article.manufaktur_artnr : '',
                        price: x.article.out_price_ex_sek * 1.25,
                        quantity: x.article.quantity
                    })
                })
                dataLayer.push({
                    event: "begin_checkout",
                    ecommerce: {
                        currency: "SEK",
                        value: state.order.rows.map(r => r.article).reduce((t, a) => t + helpers.calculateTotalInc(a), 0),
                        items: items
                    }
                });
            }

        },
        commit_current_category(state, payload) {
            console.log('payload',payload)
            state.CurrentCategory = payload
        },
        commit_current_view(state, payload) {
            state.view = payload
        },
        commit_loader(state, payload) {
            state.loader = payload
        },
        commit_transport_list(state, payload) {
            state.transport_list = payload
            let kommun = new URL(location.href).searchParams.get("kommun")
            kommun = kommun !== undefined && kommun !== null ? kommun : '4592'
            let province = state.transport_list.articles.find(x => {
                return x.article_nr.toLowerCase().includes(kommun)
            })

            state.transportProvince = province
        },
        setup_first(state, data) {
            state.activeTab = 'ProductChooser'
            state.layers = data
            let SubCategories = state.layers.flatMap(layer => layer.Categories);
            //let transportProvincePrice = state.transportProvince.out_price_ex_sek
            state.SubCategories = SubCategories
            const firstObjectWithFalseValue = state.SubCategories.find(object => object.HideForCustomer === false)
            state.view = firstObjectWithFalseValue.category_nr
            state.CurrentCategory = firstObjectWithFalseValue
            state.SubCategories.forEach(x => {

                /**update transport price */
              /*  if (x.category_nr === '14') {
                    x.LinkedArticles.forEach((x) => {
                        x.article.out_price_ex_sek = parseFloat(x.article.out_price_ex_sek) //+ parseFloat(transportProvincePrice)
                    })
                }*/
                /**end update transport price */

                if (state.order.rows.length <= 0) {
                    /* choose the first item in the begining because order.rows is empty */
                    state.order.rows.push(x.LinkedArticles[0])
                    /* end choose the first item in the begining because order.rows is empty */
                } else {
                    if (x.LinkedArticles.length > 0) {
                        x.LinkedArticles.forEach(function (a) {

                            let if_string_ = a.article.if_string.toString().split(',')

                            let if_string = if_string_.map(item => parseInt(item.trim(), 10));

                            /!* convert array of strings into integers *!/

                            if_string.forEach(m => {
                                let new_order_row = state.order.rows.map(function (b) {
                                    return parseInt(b.article.article_nr)
                                })

                                let matches = findMatchingElements(new_order_row, if_string)

                                let toBeReplacedIndex = -1
                                if (new_order_row.includes(m) || isNaN(m)) {


                                    let subCategoryId = a.article.sub_category
                                    let findSubCategory = state.order.rows.find(j => j.article.sub_category === subCategoryId)
                                    if (findSubCategory === undefined) {
                                        if (toBeReplacedIndex !== -1) {
                                            state.order.rows.splice(toBeReplacedIndex, 0, a)
                                            toBeReplacedIndex = -1
                                        } else {
                                            state.order.rows.push(a)
                                        }

                                    }
                                } else {

                                    let index = state.order.rows.findIndex(x => x.article.article_nr === a.article.article_nr)

                                    if (index !== -1) {
                                        if (matches.length <= 0) {
                                            state.order.rows.splice(index, 1)
                                            toBeReplacedIndex = index
                                        }

                                    }
                                }


                            })

                        })
                    }


                }


            })


            state.order.rows.sort(function (a, b) {
                return a.article.customOrder - b.article.customOrder
            });
            state.loader = false
        },
        logic(state, data) {
            state.SubCategories.forEach(x => {
                if (x.LinkedArticles.length > 0) {
                    x.LinkedArticles.forEach(function (a) {
                        let if_string_ = a.article.if_string.toString().split(',')
                        let if_string = if_string_.map(item => parseInt(item.trim(), 10));

                        /!* convert array of strings into integers *!/

                        if_string.forEach(m => {
                            let new_order_row = state.order.rows.map(function (b) {
                                return parseInt(b.article.article_nr)
                            })

                            let matches = findMatchingElements(new_order_row, if_string)

                            let toBeReplacedIndex = -1
                            if (new_order_row.includes(m) || isNaN(m)) {


                                let subCategoryId = a.article.sub_category
                                let findSubCategory = state.order.rows.find(j => j.article.sub_category === subCategoryId)
                                if (findSubCategory === undefined) {
                                    if (toBeReplacedIndex !== -1) {
                                        state.order.rows.splice(toBeReplacedIndex, 0, a)
                                        toBeReplacedIndex = -1
                                    } else {
                                        state.order.rows.push(a)
                                    }

                                }
                            } else {

                                let index = state.order.rows.findIndex(x => x.article.article_nr === a.article.article_nr)

                                if (index !== -1) {
                                    if (matches.length <= 0) {
                                        state.order.rows.splice(index, 1)
                                        toBeReplacedIndex = index
                                    }

                                }
                            }


                        })

                    })
                }


            })


            state.order.rows.sort(function (a, b) {
                return a.article.customOrder - b.article.customOrder
            });
            state.loader = false
        },
    },
    actions: {
        resetPrefab({commit, dispatch, rootState}) {
            commit('commit_activeTab', 'ProductChooser')
            commit('commit_current_view', '14')
           // commit('setup_first', rootState.state.layers)
         },

        async initHouse({commit, dispatch, rootState}) {
            let HousePostId = window.prefabHouse !== undefined ? window.prefabHouse : 99917
            let lang = window.myLang !== undefined ? window.myLang : 'swe'
           // let kommun = window.kommun !== undefined ? window.kommun : 4812

           /* await axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/init_transport_list', {
                params: {
                    houseNr: HousePostId,
                    kommun: kommun
                }
            }).then(res => {
                if (res.data !== '') {
                    commit('commit_transport_list', res.data)
                }


            }) */
            let url = window.PrefabApiUrl !== undefined ? window.PrefabApiUrl : process.env.VUE_APP_PUBLIC_API_URL
            await axios.get(url + '/init_byggonline_builder_prefab', {
                params: {
                    houseNr: HousePostId,
                    lang:lang
                   // kommun: kommun
                }
            }).then(res => {
                commit("setup_first", Object.freeze(res.data));
            })
        },
    },
    modules: {}
})

function findMatchingElements(arr1, arr2) {
    const set2 = new Set(arr2);
    return arr1.filter(item => set2.has(item));
}
